// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DunningDraftController = function ($scope, $http, Dunning, DunningDownloadByFilter, DunningsCount, DunningSettings,
    DocumentTemplate, DatepickerUtils) {
    $scope.isL = false;
    $scope.dateRange = { dateFrom: null, dateTo: null };
    $scope.search = "";
    $scope.templateId = "";
    
    $scope.hideDunningCounter = true;
    
    function isFilterEmpty(searchParams){
        for(var it in searchParams) {
            if(searchParams.hasOwnProperty(it) && searchParams[it] && it != 'drafts') {
                return false
            }
        }
        return true;
    }

    function getSearchParams() {
        return {
            search: $scope.search,
            dateFrom: $scope.dateRange.dateFrom,
            dateTo: $scope.dateRange.dateTo,
            drafts: true,
            templateId: $scope.templateId
        };
    }

    $scope.updateFilter = function () {
        var searchParams = getSearchParams();
        $scope.documents = $scope.paginator(function (options, callback) {
            return Dunning.query(options, function () {
                callback();
                
                if(!($scope.hideDunningCounter = !isFilterEmpty(searchParams))) {
                    updatedDunningsCount();
                }
            });
        }, searchParams, 20);
    };
    $scope.navigation = 'partials/outbox.html' + $scope.linkVersion;
    $scope.doctype = 'dunning-drafts';
    $scope.updateFilter();
    $scope.isSendRequestProcessing = false;
    
    $scope.sendDunning = function (draftId) {
        if($scope.isSendRequestProcessing) {
            return;
        }        
        
        $scope.isSendRequestProcessing = true;
        
        $http({
            method: "POST", url: "/api/v1/Dunnings/" + draftId + "/send", params: null,
            data: {}, headers: {}, cache: false
        }).then(function () {
            $scope.updateFilter();
        }).finally(function () {
            $scope.isSendRequestProcessing = false;
        });
    };

    $scope.$watch("templateId", function () {
        if (!$scope.templateId) {
            $scope.templateId = '';
        }
    });
    var docType = "Dunning";
    $scope.dunningSettings = DunningSettings.get();
    var loadTemplates = function () {
        $scope.templates = DocumentTemplate.query({ documentType: docType }, function (data) {
            if (data && data.length > 0) {
                //  $scope.selectedTemplateId = data[0].Id;
                $scope.selectTemplate();
            }
            else {
                $scope.templateId = null;
                $scope.selectedTemplate = null;
            }
        });
    }
    $scope.selectTemplate = function () {
        for (var i = 0; i < $scope.templates.length; i++) {
            if ($scope.templates[i].Id == $scope.templateId) {
                $scope.selectedTemplate = $scope.templates[i];
                break;
            }
        }
    }

    $scope.downloadByFilter = function () {
        var searchParams = getSearchParams();
        searchParams.isDownload = true;
        var download = function () {
            $scope.isL = true;
            var downloadInfo = new DunningDownloadByFilter();
            downloadInfo.$save({
                isDownload: true,
                search: searchParams.search,
                dateFrom: searchParams.dateFrom,
                dateTo: searchParams.dateTo,
                templateId: searchParams.templateId,
                drafts: true
            }, function () {
                if (downloadInfo.IsFileCountExceeded) {
                    $scope.notify("warning", gettextCatalog.getString(gettext("The maximum permissible number of documents 500. Please refine your filter criteria.")));
                } else {
                    window.location = downloadInfo.Url;
                }
                $scope.isL = false;
            }, function () { $scope.isL = false; });
        };
        $scope.updateFilter(download);
    };

    $scope.dunningsCount = 0;
    function updatedDunningsCount() {
        DunningsCount.get(getSearchParams(), function (data) {
            $scope.dunningsCount = (data && data.Count) ? data.Count : 0;
        });
    }
    
    loadTemplates();
};
DunningDraftController.$inject = ['$scope', '$http', 'Dunning', 'DunningDownloadByFilter', 'DunningsCount',
    'DunningSettings', 'DocumentTemplate', 'DatepickerUtils'];
